var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUsdCircle = function SvgUsdCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "M15.584 12.75h5.666a1.417 1.417 0 1 0 0-2.834h-2.833V8.5a1.417 1.417 0 0 0-2.833 0v1.416a4.25 4.25 0 0 0 0 8.5h2.833a1.417 1.417 0 0 1 0 2.834H12.75a1.417 1.417 0 0 0 0 2.833h2.834V25.5a1.417 1.417 0 1 0 2.833 0v-1.417a4.25 4.25 0 0 0 0-8.5h-2.833a1.417 1.417 0 0 1 0-2.833M17 1.417a15.583 15.583 0 1 0 0 31.166 15.583 15.583 0 0 0 0-31.166m0 28.333a12.75 12.75 0 1 1 0-25.5 12.75 12.75 0 0 1 0 25.5"
  })));
};
export default SvgUsdCircle;